var $1bd239d2d6ddff48$exports = {};
$1bd239d2d6ddff48$exports = {
    "backButton": (args)=>`Gr\u{12F}\u{17E}ti \u{12F} ${args.prevMenuButton}`,
    "moreActions": `Daugiau veiksm\u{173}`,
    "unavailable": `Nepasiekiama, nor\u{117}dami gauti daugiau informacijos, i\u{161}skleiskite`
};


export {$1bd239d2d6ddff48$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
